import { writable, readable } from "svelte/store";

const createWritableLocalStore = (key, startValue) => {
  const { subscribe, set } = writable(startValue);
  const json = localStorage.getItem(key);

  if (json) {
    set(JSON.parse(json));
  }

  subscribe(current => {
    localStorage.setItem(key, JSON.stringify(current));
  });

  const remove = () => {
    localStorage.removeItem(key);
    set("");
  };

  return {
    subscribe,
    set,
    remove
  };
};

export const user = createWritableLocalStore("user", "");

export const goals = readable({
  helse: 33,
  samfunn: 33
});

function isWebAppStandalone() {
  // #:standalone added in manifest.json
  const STANDALONE = ":standalone:";
  const hash = window.location.hash;

  let standalone = false;

  if (hash === "#" + STANDALONE) {
    standalone = true;
    history.replaceState(history.state, "", "/");
  }

  if (matchMedia("(display-mode)").matches && matchMedia("(display-mode: standalone)").matches) {
    return true;
  }

  if (window.navigator.standalone) {
    return true;
  }

  if (standalone) {
    sessionStorage.setItem(STANDALONE, "1");
  } else if (sessionStorage.getItem(STANDALONE)) {
    standalone = true;
  }
  
  return standalone;
}

export const appMode = readable(isWebAppStandalone());
